import React from 'react';
import './sidebar.css';
import { Link } from 'react-router-dom';

type SidebarItemProps = {
  current: string;
  name: string;
  link: string;
  icon?: string;
  matchKey?: string;
};

const SidebarItem: React.FC<SidebarItemProps> = ({ current, name, link, icon, matchKey }) => (
  <Link
    to={link}
    title={name}
    onClick={(e) => link === 'unauthorized' && e.preventDefault()}
    className={`flex container py-4 gap-1 align-items-center border-l-8 border-primary_text hover:border-red hover:bg-red hover:bg-opacity-30 ${current === (matchKey || name) ? 'bg-red bg-opacity-50 border-red hover:bg-opacity-50' : ''
      } ${link === 'unauthorized' ? ' opacity-50' : ''} cursor-pointer`}
  >
    {icon ? icon : <img className="w-6 h-6" src={`/assets/icons/flat/${(matchKey || name).toLocaleLowerCase()}.png`} alt="" />}
    <div className="w-40 hidden 2xl:flex text-white text-sm font-bold ps-1 text-nowrap">{name}</div>
  </Link>
);

type SidebarProps = {
  items: any[];
  currentItem: string;
  isAdmin: boolean;
  isSuperadmin: boolean;
};

const Sidebar: React.FC<SidebarProps> = ({ items, currentItem, isAdmin, isSuperadmin }) => {
  // Filter out admin-only and superadmin-only items
  const visibleItems = items.filter(item => {
    if (item.isSuperadminOnly) return isSuperadmin;
    if (item.isAdminOnly) return isAdmin;
    return true;
  });

  return (
    <aside className="bg-primary_text ">
      <div className="m-3">
        <div className="mx-auto">
          <img
            className="w-[2rem] h-[2rem] block 2xl:hidden" // Show on small and medium screens, hide on large and extra-large screens
            src="/assets/icons/spotlock/spotlock-logo-notext.svg"
            alt=""
          />
          <img
            className="w-[12rem] h-[2rem] hidden 2xl:block" // Show on large and extra-large screens, hide on small and medium screens
            src="/assets/icons/spotlock/spotlock-logo-wtext.png"
            alt=""
          />
        </div>
      </div>
      <ul>
        {visibleItems.map((item, index) => (
          <SidebarItem
            current={currentItem}
            key={index}
            name={item.name}
            link={item.link}
            icon={item.icon}
            matchKey={item.matchKey}
          />
        ))}
      </ul>
    </aside>
  );
};
export default Sidebar;
